import React from 'react';
import {WorkbenchState} from "../../types/WorkbenchState";

/**
 * Creates the workbench state context with initial value.
 */
export const WorkbenchStateContext = React.createContext({});

type WorkbenchStateContextProviderProps = {
  state: WorkbenchState
  onUpdate: () => void
}

/**
 * Provider for the workbench state context.
 */
class WorkbenchStateContextProvider extends React.Component<WorkbenchStateContextProviderProps> {

  constructor(props: WorkbenchStateContextProviderProps) {
    super(props);
    this.canRead = this.canRead.bind(this);
    this.canCreate = this.canCreate.bind(this);
  }

  private canRead() {
    if (this.props.state.security?.user) {
      return this.props.state.security.user.permissions.canRead;
    }
    return true;
  }

  private canCreate() {
    if (this.props.state.security?.user) {
      return this.props.state.security.user.permissions.canCreate;
    }
    return true;
  }

  render() {
    const value = {
      ...this.props.state,
      onUpdate: this.props.onUpdate,
      canRead: this.canRead,
      canCreate: this.canCreate
    };
    return (
      <WorkbenchStateContext.Provider value={value}>
        {this.props.children}
      </WorkbenchStateContext.Provider>
    );
  }
}

export default WorkbenchStateContextProvider;
